/**
 * Converts an alpha numeric id to an unique color
 *
 * @returns RGB color string without "#"-prefix
 */
export const alnumIdToColor = (id: string): string => {
  let hash = 0;
  for (let index = 0; index < id.length; index++) {
    hash = id.charCodeAt(index) + ((hash << 5) - hash);
  }
  // eslint-disable-next-line prettier/prettier
  // eslint-disable-next-line unicorn/number-literal-case
  const c = (hash & 0x00ffffff).toString(16).toUpperCase();
  const result = '00000'.slice(0, Math.max(0, 6 - c.length)) + c;
  return result;
};

/**
 * Converts an string to an unique color
 *
 * @returns hex color string
 */
export const stringToColor = (input: string): string => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0x00ffffff;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};
